// Account provenance — the `user_origin` claim the backend stamps on a token
// (Story 16.2). Mirrors the backend enum `UserOrigin`, whose canonical value is
// `UserOrigin.webapp_legacy.value`. The SPA compares this value in several
// legacy-gate decisions (auth context, profile cards, register screen); keep the
// literal here in ONE place so a backend rename surfaces as a single FE edit
// instead of a scattered string hunt.

/** The web-app legacy-import origin — a clinician who signed up through the
 *  legacy web-app flow and is disabled-by-default until cert + payment clear. */
export const USER_ORIGIN_WEBAPP_LEGACY = "webapp_legacy";

/** The LearnWorlds origin — an account whose course record is matched BY EMAIL
 *  ADDRESS. Anything that changes the sign-in email has to warn about that
 *  (Story 14.9 AC5), so the literal belongs here beside its sibling. */
export const USER_ORIGIN_LEARNWORLDS_NEW = "learnworlds_new";
